import { render, staticRenderFns } from "./LoeschenModal.vue?vue&type=template&id=4f30917a"
import script from "./LoeschenModal.vue?vue&type=script&lang=js"
export * from "./LoeschenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports